'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { type FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { celebritiesListOptions } from '@/entities/Celebrity/api/celebritiesList';
import useDebounce from '@/hooks/useDebounce';
import { SearchSelect, type SearchSelectOption } from './SearchSelect/SearchSelect';
export interface CelebrityOptionSelect {
  value: number;
  label: string;
}
interface CelebritySearchSelectProps {
  value?: number[];
  onChange: (value: number[]) => void;
  placeholder?: string;
  className?: string;
  allowClear?: boolean;
  searchValue?: string;
  setSearchValue?: (value: string) => void;
  /** Вызывается при выборе опции (id и имя для API по имени) */
  onOptionSelect?: (option: CelebrityOptionSelect) => void;
}
export const CelebritySearchSelect: FC<CelebritySearchSelectProps> = t0 => {
  const $ = _c(31);
  const {
    value: t1,
    onChange,
    placeholder,
    className: t2,
    allowClear: t3,
    searchValue: _searchValue,
    setSearchValue: _setSearchValue,
    onOptionSelect
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const value = t4;
  const className = t2 === undefined ? "" : t2;
  const allowClear = t3 === undefined ? true : t3;
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const prevValueRef = useRef(value);
  let t5;
  let t6;
  if ($[2] !== value) {
    t5 = () => {
      prevValueRef.current = value;
    };
    t6 = [value];
    $[2] = value;
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  useEffect(t5, t6);
  let t7;
  if ($[5] !== _searchValue || $[6] !== searchValue) {
    t7 = () => {
      setDebouncedSearchValue(_searchValue ?? searchValue ?? "");
    };
    $[5] = _searchValue;
    $[6] = searchValue;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  useDebounce(t7, 500);
  const t8 = debouncedSearchValue.length >= 2 ? debouncedSearchValue : undefined;
  let t9;
  if ($[8] !== t8) {
    t9 = celebritiesListOptions({
      name: t8
    });
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const {
    data: t10,
    isFetching
  } = useQuery(t9);
  let t11;
  if ($[10] !== t10) {
    t11 = t10 === undefined ? [] : t10;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const celebritiesList = t11;
  let t12;
  bb0: {
    if (celebritiesList.length > 0) {
      let t13;
      if ($[12] !== celebritiesList) {
        t13 = celebritiesList.map(_temp);
        $[12] = celebritiesList;
        $[13] = t13;
      } else {
        t13 = $[13];
      }
      t12 = t13;
      break bb0;
    }
    let t13;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = [];
      $[14] = t13;
    } else {
      t13 = $[14];
    }
    t12 = t13;
  }
  const selectOptions = t12;
  let t13;
  if ($[15] !== onChange || $[16] !== onOptionSelect || $[17] !== selectOptions) {
    t13 = newValue => {
      if (onOptionSelect && newValue.length > prevValueRef.current.length) {
        const addedId = newValue.find(id => !prevValueRef.current.includes(id));
        const addedOption = selectOptions.find(o => o.value === addedId);
        if (addedOption) {
          onOptionSelect({
            value: Number(addedOption.value),
            label: addedOption.label
          });
        }
      }
      prevValueRef.current = newValue;
      onChange(newValue.map(Number));
    };
    $[15] = onChange;
    $[16] = onOptionSelect;
    $[17] = selectOptions;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const handleChange = t13;
  let t14;
  if ($[19] !== handleChange) {
    t14 = val => handleChange(val.map(Number));
    $[19] = handleChange;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const t15 = _searchValue ?? searchValue ?? "";
  const t16 = _setSearchValue ?? setSearchValue;
  let t17;
  if ($[21] !== allowClear || $[22] !== className || $[23] !== isFetching || $[24] !== placeholder || $[25] !== selectOptions || $[26] !== t14 || $[27] !== t15 || $[28] !== t16 || $[29] !== value) {
    t17 = <SearchSelect value={value} onChange={t14} isFetching={isFetching} placeholder={placeholder} className={className} options={selectOptions} searchValue={t15} setSearchValue={t16} allowClear={allowClear} />;
    $[21] = allowClear;
    $[22] = className;
    $[23] = isFetching;
    $[24] = placeholder;
    $[25] = selectOptions;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = value;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
};
function _temp(item) {
  return {
    value: item.id,
    label: item.first_name + " " + item.last_name
  };
}